// @ts-ignore
import React from "react";
// import myCV from "../../assets/images/MyCV.pdf";
import Reveal from "react-reveal/Reveal";
import Fade from "react-reveal/Fade";
import Cards from "../../components/skillsCards/Cards";
import Blast from "../../components/BlastAnimation/Blast"
import "./about.scss";

const About = () => {
  const [letterClass, setLetterClass] = React.useState("text-animate");
  React.useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3000);
  }, []);

  return (
    <>
      <Reveal delay={1000}>
        <div className="fake-big">About</div>
      </Reveal>
      <div className="section-about-wrapper section__padding">
        <article className="section-about-description">
          <div>
            <h2 arial-aria-label="About and skills">
              <Blast
                letterClass={letterClass}
                arrayStr={["About", " ", "&", " ", "Skills"]}
                indexLetter={15}
              />
            </h2>
            <Fade bottom>
              <p>
                As a driven and ambitious Software developer, I am seeking an
                opportunity in a mature established Company. I would like to
                work with the cutting-edge technologies on challenging and
                diverse projects.
              </p>
              <br />
            </Fade>
            <Fade bottom>
              <p>
                I have a background in developing efficient software
                applications in a global market.Some of my accomplishments
                include more than 1300 hours of experience, including mentoring 10+ junior developers to achieve concrete goals within a strict deadline. I have collaborated on a number of projects with other developers from
                different countries while putting in more than eight hours a day
                of coding. Communication, leadership, and cooperative teamwork
                are some of the skills I have mastered.As noted in my GitHub profile, my
                strong skills include React, Redux, JavaScript, Ruby on Rails,
                Figma, and animation libraries are among my strong skills.I have
                also received an award of honor for best student in the Code
                First Girls python course.My ability to function well in hectic
                situations and my background are two of my most intriguing
                qualities.
              </p>
            </Fade>
            <Fade bottom>
              <p>
                One of the most interesting things about me is that I thrive in
                fast-paced environments and have a proven history of delivering
                results under tight deadlines, as evidenced by my previous
                experience and accomplishments. Here's my CV for your review.

                Thanks in advance for your time spent reading my accomplishments
                and work history.
              </p>
            </Fade>
            <Fade left>
              <a
                style={{ marginTop: "2rem" }}
                href="https://drive.google.com/file/d/1elOPUzCWc_M58ZVZiMUbx7PjF4N3tQog/view?usp=sharing"
                className="contact-button submit-button"
                target="_blank"
                rel="noreferrer"
              >
                <div>
                  <span className="bg switch__bg"></span>
                  <span className="base switch__border-color"></span>
                  <span className="text">Download CV/Resume</span>
                </div>
              </a>
            </Fade>
          </div>
        </article>
        <h2
          arial-aria-label="About and skills"
          style={{ "font-size": "2.5em" }}
        >
          <Blast
            letterClass={letterClass}
            arrayStr={["My", "", "Skills"]}
            indexLetter={15}
          />
        </h2>
        {/* programming language cards */}
        <Cards />
      </div>
    </>
  );
};

export default About;
